import React, { useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const Slider = ({ images, description, githubLink, title }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + images.length) % images.length);
  };

  return (
    <div className="flex align-middle justify-center flex-col w-full space-y-4 dark:bg-opacity-25 dark:bg-gray-700 p-4 rounded-lg shadow-2xl relative backdrop-blur-sm mb-10 z-20 items-center md:items-start pr-3 md:mb-0">
      <div className="relative w-full flex justify-center items-center">
        <button
          onClick={prevSlide}
          className="absolute left-0 bg-gray-700 dark:bg-gray-500 text-white p-2 rounded-full m-2 hover:bg-gray-600 dark:hover:bg-gray-400 z-10"
        >
          <FaArrowLeft />
        </button>
        <div className="relative w-10/12 overflow-hidden">
          <div className="flex transition-transform duration-500" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
            {images.map((img, index) => (
              <img key={index} src={img} alt={`Slide ${index + 1}`} className="w-full skeleton object-cover rounded-md" />
            ))}
          </div>
        </div>
        <button
          onClick={nextSlide}
          className="absolute right-0 bg-gray-700 dark:bg-gray-500 text-white p-2 rounded-full m-2 hover:bg-gray-600 dark:hover:bg-gray-400 z-10"
        >
          <FaArrowRight />
        </button>
      </div>
      <div className="flex w-full justify-center space-x-2 mt-2">
        {images.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full ${index === currentSlide ? 'bg-blue-500 dark:bg-blue-300' : 'bg-gray-300 dark:bg-gray-500'}`}
          ></div>
        ))}
      </div>
      <h3 className="text-xl font-semibold flex items-center mt-4">
        {title}
      </h3>
      <p>{description}</p>
      {githubLink && (
        <a href={githubLink} target="_blank" rel="noopener noreferrer" className="text-green-300 dark:text-blue-300 hover:underline flex items-center">
          View on GitHub <FaArrowRight className="ml-1" />
        </a>
      )}
    </div>
  );
};

export default Slider;
